import profilePic from './images/profile-circle.png'
import book from './images/book.svg'
import archive from './images/archive-book.png'
import refresh from './images/refresh-right-square.png'
import notification from './images/notification-bing.svg'
import card from './images/cards.svg'
import heart from './images/heart-add.svg'
import review from './images/chart-success.png';
import ibomAir from './images/ibom-air.png'
import ethiopianAir from './images/ethiopian-air.png'
import nigerianAir from './images/Nigerian-air.png'
import protea from './images/protea.svg'
import protea1 from './images/protea-1.svg'
import protea2 from './images/protea-2.svg'
import protea3 from './images/protea-3.svg'
import protea4 from './images/protea-4.svg'
import protea5 from './images/protea-5.svg'
import protea6 from './images/protea-6.svg'
import car1 from './images/car (2).png'
import car2 from './images/car(1).png'
import car3 from './images/car2.png'
import car4 from './images/car3.png'
import car5 from './images/car4.png'
import car6 from './images/car5.png'
import { FaFacebook, FaGoogle , FaInstagramSquare} from 'react-icons/fa'
import google from './images/google.svg'
export const carPickUpTime = ['8:00A.M.', '12:00P.M.', '3:00P.M.']
export const carClasses = ['Economy', 'Standard', 'Premium'];
export const carTypes = ['SUV', 'Sedan', 'Buses', 'Trucks'];
export const flightClasses = ['Economy', 'Business', 'First'];
export const flightType = ['Round trip', 'One way Trip'];
export const passengers = ['Adult', 'Child/Children', 'Adult & Childen'];
export const locations = ['ABJ (Abuja)', 'LOS (Lagos)', 'OGN (Ogun)', 'KAN (Kano)', 'OWR (Owerri)', 'PH (Port-Harcourt)'];

export const allFaq = [
    
       
    {
        id: 1,
        question:' How do I make a booking',
        answer:'To make a booking, simply enter your destination and travel dates on our website and select your preferred flights and accommodations. Once you have made your selections, you can proceed to the checkout page and enter your personal information and payment details to confirm your booking.',
    },
    {
        id: 2,
        question:' How do I explore destinations',
        answer:'You can check out popular places to visit on our home page.',
    },
   
    {
        id: 3,
        question:'Can I make a booking over the phone?',
        answer:'Yes, you can make a booking over the phone by calling our customer service hotline. Our agents will assist you with selecting flights and accommodations and guide you through the booking process.',
    },
    {
        id: 4,
        question:' Can I make changes to my booking after it has been confirmed?',
        answer:'Yes, you can make changes to your booking by logging into your account on our website or contacting our customer service team. Please note that changes may be subject to additional fees or charges.',
    },
    {
        id: 5,
        question:'Can I make a call for enquiries?',
        answer:'Yes, you can calling customer service hotline. Our agents will assist you with popular destinations and nice places to visit.',
    },
    {
        id: 6,
        question:'  How do I know if my booking is confirmed?',
        answer:'After you have completed your booking, you will receive a confirmation email with your itinerary and booking details. You can also log into your account on our website to view your booking information',
    },
    {
        id: 7,
        question:' How do I book an accommodation',
        answer:'To book an accommodation, simply enter your destination and check-in dates on our website and select your preferred accommodations. Once you have made your selections, you can proceed to the checkout page and enter your personal information and payment details to confirm your accommodation.',
    },
    {
        id: 8,
        question:'Can I make a accommodation over the phone?',
        answer:'Yes, you can make a accommodation over the phone by calling our customer service hotline. Our agents will assist you with selecting flights and accommodations and guide you through the accommodation process.',
    },
    {
        id: 9,
        question:' Can I make changes to my accommodation after it has been confirmed?',
        answer:'Yes, you can make changes to your accommodation by logging into your account on our website or contacting our customer service team. Please note that changes may be subject to additional fees or charges.',
    },
   
    {
        id: 10,
        question:'How can I cancel my booking?',
        answer:'To cancel your booking, log into your account on our website and select the booking you wish to cancel. Follow the prompts to request a cancellation and receive a refund, if applicable.',
    },
    {
        id: 11,
        question:'  How do I know if my flights is confirmed?',
        answer:'After you have completed your flights, you will receive a confirmation email with your itinerary and flights details. You can also log into your account on our website to view your flights information',
    },
    {
        id: 12,
        question:'How can I cancel my flights?',
        answer:'To cancel your flights, log into your account on our website and select the flights you wish to cancel. Follow the prompts to request a cancellation and receive a refund, if applicable.',
    },
    {
        id: 13,
        question:'  How do I know if my accommodation is confirmed?',
        answer:'After you have completed your accommodation, you will receive a confirmation email with your itinerary and accommodation details. You can also log into your account on our website to view your accommodation information',
    },
    {
        id: 14,
        question:'How can I cancel my accommodation?',
        answer:'To cancel your accommodation, log into your account on our website and select the accommodation you wish to cancel. Follow the prompts to request a cancellation and receive a refund, if applicable.',
    },  {
        id: 15,
        question:' How do I book a flight',
        answer:'To book a flights, simply enter your destination and travel dates on our website and select your preferred flights. Once you have made your selections, you can proceed to the checkout page and enter your personal information and payment details to confirm your flights.',
    },
    {
        id: 16,
        question:'Can I book flights over the phone?',
        answer:'Yes, you can make a flights over the phone by calling our customer service hotline. Our agents will assist you with selecting flights and accommodations and guide you through the flights process.',
    },
    {
        id: 17,
        question:' Can I make changes to my flights after it has been confirmed?',
        answer:'Yes, you can make changes to your flights by logging into your account on our website or contacting our customer service team. Please note that changes may be subject to additional fees or charges.',
    },
   
    
]
export const bookingFaq = [
    {
        id: 1,
        question:' How do I make a booking',
        answer:'To make a booking, simply enter your destination and travel dates on our website and select your preferred flights and accommodations. Once you have made your selections, you can proceed to the checkout page and enter your personal information and payment details to confirm your booking.',
    },
    {
        id: 2,
        question:'Can I make a booking over the phone?',
        answer:'Yes, you can make a booking over the phone by calling our customer service hotline. Our agents will assist you with selecting flights and accommodations and guide you through the booking process.',
    },
    {
        id: 3,
        question:' Can I make changes to my booking after it has been confirmed?',
        answer:'Yes, you can make changes to your booking by logging into your account on our website or contacting our customer service team. Please note that changes may be subject to additional fees or charges.',
    },
    {
        id: 4,
        question:'  How do I know if my booking is confirmed?',
        answer:'After you have completed your booking, you will receive a confirmation email with your itinerary and booking details. You can also log into your account on our website to view your booking information',
    },
    {
        id: 5,
        question:'How can I cancel my booking?',
        answer:'To cancel your booking, log into your account on our website and select the booking you wish to cancel. Follow the prompts to request a cancellation and receive a refund, if applicable.',
    },
   
]
export const flightFaq = [
    {
        id: 1,
        question:' How do I book a flight',
        answer:'To book a flights, simply enter your destination and travel dates on our website and select your preferred flights. Once you have made your selections, you can proceed to the checkout page and enter your personal information and payment details to confirm your flights.',
    },
    {
        id: 2,
        question:'Can I make a flights over the phone?',
        answer:'Yes, you can make a flights over the phone by calling our customer service hotline. Our agents will assist you with selecting flights and accommodations and guide you through the flights process.',
    },
    {
        id: 3,
        question:' Can I make changes to my flights after it has been confirmed?',
        answer:'Yes, you can make changes to your flights by logging into your account on our website or contacting our customer service team. Please note that changes may be subject to additional fees or charges.',
    },
    {
        id: 4,
        question:'  How do I know if my flights is confirmed?',
        answer:'After you have completed your flights, you will receive a confirmation email with your itinerary and flights details. You can also log into your account on our website to view your flights information',
    },
    {
        id: 5,
        question:'How can I cancel my flights?',
        answer:'To cancel your flights, log into your account on our website and select the flights you wish to cancel. Follow the prompts to request a cancellation and receive a refund, if applicable.',
    },
   
]
export const accommodationFaq = [
    {
        id: 1,
        question:' How do I book an accommodation',
        answer:'To book an accommodation, simply enter your destination and check-in dates on our website and select your preferred accommodations. Once you have made your selections, you can proceed to the checkout page and enter your personal information and payment details to confirm your accommodation.',
    },
    {
        id: 2,
        question:'Can I make a accommodation over the phone?',
        answer:'Yes, you can make a accommodation over the phone by calling our customer service hotline. Our agents will assist you with selecting flights and accommodations and guide you through the accommodation process.',
    },
    {
        id: 3,
        question:' Can I make changes to my accommodation after it has been confirmed?',
        answer:'Yes, you can make changes to your accommodation by logging into your account on our website or contacting our customer service team. Please note that changes may be subject to additional fees or charges.',
    },
    {
        id: 4,
        question:'  How do I know if my accommodation is confirmed?',
        answer:'After you have completed your accommodation, you will receive a confirmation email with your itinerary and accommodation details. You can also log into your account on our website to view your accommodation information',
    },
    {
        id: 5,
        question:'How can I cancel my accommodation?',
        answer:'To cancel your accommodation, log into your account on our website and select the accommodation you wish to cancel. Follow the prompts to request a cancellation and receive a refund, if applicable.',
    },
   
]

export const activitiesFaq = [
    {
        id: 1,
        question:' How do I explore destinations',
        answer:'You can check out popular places to visit on our home page.',
    },
    {
        id: 2,
        question:'Can I make a call for enquiries?',
        answer:'Yes, you can calling customer service hotline. Our agents will assist you with popular destinations and nice places to visit.',
    },
    // {
    //     id: 3,
    //     question:' Can I make changes to my booking after it has been confirmed?',
    //     answer:'Yes, you can make changes to your booking by logging into your account on our website or contacting our customer service team. Please note that changes may be subject to additional fees or charges.',
    // },
    // {
    //     id: 4,
    //     question:'  How do I know if my booking is confirmed?',
    //     answer:'After you have completed your booking, you will receive a confirmation email with your itinerary and booking details. You can also log into your account on our website to view your booking information',
    // },
    // {
    //     id: 5,
    //     question:'How can I cancel my booking?',
    //     answer:'To cancel your booking, log into your account on our website and select the booking you wish to cancel. Follow the prompts to request a cancellation and receive a refund, if applicable.',
    // },
   
]

export const carsData = [
   
    {
        id:1,
        icon:car1,
        carBrand:'Toyota Camry 2015',
        
        seats: '3',
        amount: 15000,
    }
,    {
        id:2,
        icon:car2,
        carBrand:'Hilux',
       
        seats: '5',
        amount: 20000,}
,    {
        id:3,
        icon:car3,
        carBrand:'Infinity',
        
        seats: '4',
        amount: 10000,
    }
,    {
        id:4,
        icon:car4,
        carBrand:'Toyota Corolla',
       
        seats: '2',
        amount: 20000,}
,    {
        id:5,
        icon:car5,
        carBrand:'Hilux Jeep',
        
        seats: '5',
        amount: 35000,
    }
,    {
        id:6,
        icon:car6,
        carBrand:'Mercedes Benz',
       
        seats: '4',
        amount: 32000,
    }
,   
]
export const hotelsData = [
    {
        id:1,
        icon:protea1,
        hotel:'Protea Hotels',
        location:'Lagos',
        seats: '3',
        stars: '5',
        amount: 50000,
  
    refundable:'Refundable'
    },
    {
        id:2,
        icon:protea,
        hotel:'Spring Hotels',
        location:'Port-Harcourt',
        stars: '3',
        amount: 150000,
    refundable:'Non-refundable'
    },
    {
        id:3,
        icon:protea2,
        hotel:'Kings Hotel',
        location:'Abuja',
        stars: '5',
        amount: 200000,
    refundable:'Refundable'
    },
    {
        id:4,
        icon:protea3,
        hotel:'Sprinx Inn',
        location:'Lagos',
        stars: '4',
        amount: 100000,
    refundable:'Non-refundable'
    },
    {
        id:5,
        icon:protea4,
        hotel:'Kings Suites',
        location:'Ogun',
        stars: '2',
        amount: 200000,
    refundable:'Refundable'
    },
    {
        id:6,
        icon:protea5,
        hotel:'Parktonian Hotels',
        location:'Abuja',
        stars: '5',
        amount: 350000,
    refundable:'Non-refundable'
    },
    {
        id:7,
        icon:protea6,
        hotel:'Presken Hotel',
        location:'Abuja',
        stars: '5',
        amount: 320000,
    refundable:'Non-refundable'
    },
   
]

export const flightsData = [
    {
        id:1,
        icon:nigerianAir,
        airline:'Nigerian Airways',
        departureTime:'6:30p.m.',
        from:'Lagos',
        to:'Abuja',
        arrivalTime:'9:30p.m.',
        stop:'Direct',
        duration: 3,
        amount: 250000,
    recommendation: 'Recommended flight',
    refundable:'Refundable'
    },
    {
        id:2,
        icon:ibomAir,
        airline:'Ibom Air',
        departureTime:'12:30p.m.',
        from:'Lagos',
        to:'Abuja',
        arrivalTime:'6:30p.m.',
        stop:'1 stop',
        duration: 6,
        amount: 150000,
    recommendation: '',
    refundable:'Non-refundable'
    },
    {
        id:3,
        icon:ethiopianAir,
        airline:'Ethiopian Air',
        departureTime:'12:30p.m.',
        from:'Lagos',
        to:'Abuja',
        arrivalTime:'9:30p.m.',
        stop:'2+ stops',
        duration: 9,
        amount: 50000,
    recommendation: '',
    refundable:'Refundable'
    },
    {
        id:4,
        icon:nigerianAir,
        airline:'Nigerian Airways',
        departureTime:'6:30a.m.',
        from:'Lagos',
        to:'Abuja',
        arrivalTime:'8:30a.m.',
        stop:'1 stop',
        duration: 2,
        amount: 180000,
    recommendation: 'Recommended flight',
    refundable:'Non-refundable'
    },
    {
        id:5,
        icon:ibomAir,
        airline:'Ibom Air',
        departureTime:'12:30p.m.',
        from:'Lagos',
        to:'Abuja',
        arrivalTime:'1:30p.m.',
        stop:'Direct',
        duration: 1,
        amount: 500000,
    recommendation: 'Recommended flight',
    refundable:'Refundable'
    },
    {
        id:6,
        icon:ethiopianAir,
        airline:'Ethiopian Air',
        departureTime:'8:30a.m.',
        from:'Lagos',
        to:'Abuja',
        arrivalTime:'12:30p.m',
        stop:'1 stop',
        duration: 4,
        amount: 300000,
    recommendation: 'Recommended flight',
    refundable:'Non-refundable'
    },
    {
        id:7,
        icon:nigerianAir,
        airline:'Nigerian Airways',
        departureTime:'12:30p.m.',
        from:'Lagos',
        to:'Abuja',
        arrivalTime:'5:30p.m.',
        stop:'2+ stops stop',
        duration: 5,
        amount: 180000,
    recommendation: '',
    refundable:'Refundable'
    },
    {
        id:8,
        icon:ibomAir,
        airline:'Ibom Air',
        departureTime:'6:30a.m.',
        from:'Lagos',
        to:'Abuja',
        arrivalTime:'12:30p.m.',
        stop:'2+ stops',
        duration: 6,
        amount: 80000,
    recommendation: 'Recommended flight',
    refundable:'Non-refundable'
    },
    {
        id:9,
        icon:ethiopianAir,
        airline:'Ethiopian Air',
        departureTime:'11:30a.m.',
        from:'Lagos',
        to:'Abuja',
        arrivalTime:'1:30p.m.',
        stop:'Direct',
        duration: 2,
        amount: 500000,
    recommendation: 'Recommended flight',
    refundable:'Refundable'
    },
]


export const dashboard = [
    {
        id:1,
        icon: profilePic,
        header:'Account Info',
        info:'Manage your account info and privacy settings',
    },
    {
        id:2,
        icon: book,
        header:'Travel History',
        info:'See your travel history',
    },
    {
        id:3,
        icon: heart,
        header:'Wishlist',
        info:'See all your saved items here',
    },
    {
        id:4,
        icon: archive,
        header:'Bookings',
        info:'Details of bookings/upcoming bookings',
    },
    {
        id:5,
        icon: refresh,
        header:'Travel Preferences',
        info:'Manage your travel preferences',
    },
    {
        id:6,
        icon: review,
        header:'Reviews',
        info:'See reviews made, pending reviews',
    },
    {
        id:7,
        icon: card,
        header:'Payment Methods',
        info:'Review your payment methods',
    },
    {
        id:8,
        icon: notification,
        header:'Notification',
        info:'Notification preferences and how to be contacted',
    },
]






